import React from "react";
import useSound from "use-sound";
import DBLPOP from "../../assets/music/DBLPOP.mp3";
import { useDispatch, useSelector } from "react-redux";
import { updateMode } from "../../redux/reducers/ModeReducer";
import { selectWeek } from "../../redux/reducers/PracticeDataReducer";
import ContentContainer from "../../components/ContentContainerComp/ContentContainer";
import LockIcon from "../../assets/images/others/LockIcon2.png";
import s from "./style.module.css";

const LessonContainer = ({ QuizNumber }) => {
  const userInfo = useSelector((state) => state.UserInfo);
  const grade = useSelector((state) => state.PracticeData.grade);
  const [play] = useSound(DBLPOP);
  const dispatch = useDispatch();
  const handleSelectLesson = (id) => {
    dispatch(updateMode({ mode: 2, step: 1 }));
    dispatch(selectWeek(id));
    play();
  };
  const handleback = () => {
    dispatch(updateMode({ mode: 1, step: 2 }));
  };

  const allLevel = Array.from({ length: QuizNumber }, (_, i) => i + 1);
  // const mockCompleteWeek = [
  //   { grade: 4, week: 1 },
  //   { grade: 5, week: 1 },
  //   { grade: 6, week: 1 },
  // ];
  const currentLevel = userInfo.completeWeek.filter(
    (item) => item.grade === grade
  );
  const passLevel2 = currentLevel[0].week;

  return (
    <ContentContainer
      typeHeader={1}
      onCenter
      textHeader="ด่านของฉัน"
      disableNext={1}
      // onPressNext={() => handleSelectLesson()}
      onPressBack={() => handleback()}
    >
      <div className={s.lessonContainer}>
        {allLevel.map((item) => (
          <div
            key={item}
            className={s.doorContainer}
            onClick={() => {
              passLevel2 >= item
                ? handleSelectLesson(item)
                : console.log("nope");
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "12.5vw",
                height: "20vh",
                background:
                  passLevel2 === item
                    ? "#ECC242"
                    : passLevel2 > item
                    ? "#B9C559"
                    : "#D05E43",
                border: "5px solid #FFFFFF",
                boxShadow: "1px 4px 3px rgba(0, 0, 0, 0.44)",
                borderRadius: "21px",
              }}
            >
              {passLevel2 >= item ? (
                <span
                  style={{
                    fontSize: "10vmax",
                    lineHeight: "141px",
                    textAlign: "center",
                    color: "#FFFFFF",
                    textShadow: "-1px 4px 4px rgba(0, 0, 0, 0.44)",
                  }}
                >
                  {item}
                </span>
              ) : (
                <img
                  style={{ width: "6vw", height: "12vh" }}
                  src={LockIcon}
                  alt="lockIcon"
                />
              )}
            </div>
          </div>
        ))}
      </div>
    </ContentContainer>
  );
};

export default LessonContainer;
